import { render } from "./ProgramsSection.vue?vue&type=template&id=3ea0ad8c&scoped=true"
import script from "./ProgramsSection.vue?vue&type=script&lang=js"
export * from "./ProgramsSection.vue?vue&type=script&lang=js"

import "./ProgramsSection.vue?vue&type=style&index=0&id=3ea0ad8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea0ad8c"]])

export default __exports__